// Dynamic Number Insertion (DNI) Configuration
// Edit this file to configure phone number pools and tracking

export const DNI_CONFIG = {
  // Default fallback phone number for Texas (always shown for SEO/noscript)
  DEFAULT_PHONE: '469-589-5357',
  
  // California CallRail tracking number
  DEFAULT_PHONE_CA: '951-904-2370',
  
  // Houston CallRail tracking number
  DEFAULT_PHONE_HOUSTON: '713-730-2453',
  
  // Austin CallRail tracking number
  DEFAULT_PHONE_AUSTIN: '512-601-4784',
  
  // San Antonio CallRail tracking number
  DEFAULT_PHONE_SAN_ANTONIO: '210-934-4746',
  
  // Enable/disable providers
  USE_CALLRAIL: true,  // Primary - uses CallRail's script
  USE_TWILIO_ROUTER: false, // Fallback - custom JS router
  
  // CallRail account settings
  CALLRAIL: {
    SWAP_CLASS: 'callrail-phone',
    SWAP_SELECTOR: '.callrail-phone, [data-phone-swap="true"], a[data-tel="main"], .phone-swap',
  },
  
  // City-based tracking pools (for Twilio router)
  CITY_POOLS: {
    // Dallas-Fort Worth Metro (Texas)
    'dallas': '469-589-5357',
    'fort-worth': '469-589-5357',
    'arlington': '469-589-5357',
    'plano': '469-589-5357',
    'frisco': '469-589-5357',
    'mckinney': '469-589-5357',
    'irving': '469-589-5357',
    'garland': '469-589-5357',
    'grand-prairie': '469-589-5357',
    'denton': '469-589-5357',
    'allen': '469-589-5357',
    'richardson': '469-589-5357',
    'lewisville': '469-589-5357',
    'carrollton': '469-589-5357',
    'mesquite': '469-589-5357',
    
    // Houston Metro (Texas) - Uses Houston-specific tracking
    'houston': '713-730-2453',
    'pearland': '713-730-2453',
    'sugar-land': '713-730-2453',
    'katy': '713-730-2453',
    'the-woodlands': '713-730-2453',
    'pasadena': '713-730-2453',
    'league-city': '713-730-2453',
    'baytown': '713-730-2453',
    'conroe': '713-730-2453',
    
    // Austin Metro (Texas) - Uses Austin-specific tracking
    'austin': '512-601-4784',
    'round-rock': '512-601-4784',
    'cedar-park': '512-601-4784',
    'pflugerville': '512-601-4784',
    'georgetown': '512-601-4784',
    'lakeway': '512-601-4784',
    
    // San Antonio Metro (Texas) - Uses San Antonio-specific tracking
    'san-antonio': '210-934-4746',
    'new-braunfels': '210-934-4746',
    'boerne': '210-934-4746',
    'helotes': '210-934-4746',
    'schertz': '210-934-4746',
    'cibolo': '210-934-4746',
    
    // California - Inland Empire (showroom)
    'inland-empire': '951-904-2370',
    'riverside': '951-904-2370',
    'corona': '951-904-2370',
    'moreno-valley': '951-904-2370',
    'fontana': '951-904-2370',
    'ontario': '951-904-2370',
    'rancho-cucamonga': '951-904-2370',
    'temecula': '951-904-2370',
    'murrieta': '951-904-2370',
    'san-bernardino': '951-904-2370',
    
    // California - Los Angeles (service area)
    'los-angeles': '951-904-2370',
    'pasadena-ca': '951-904-2370',
    'glendale': '951-904-2370',
    'long-beach': '951-904-2370',
    'santa-monica': '951-904-2370',
    'burbank': '951-904-2370',
  } as Record<string, string>,
  
  // Campaign-based tracking pools (for Twilio router)
  CAMPAIGN_POOLS: {
    'google_ads_brand': '469-589-5357',
    'google_ads_outdoor_kitchen': '469-589-5357',
    'google_ads_bbq_island': '469-589-5357',
    'facebook_retargeting': '469-589-5357',
    'facebook_prospecting': '469-589-5357',
  } as Record<string, string>,
  
  // Source-based tracking pools (for Twilio router)
  SOURCE_POOLS: {
    'google': '469-589-5357',
    'facebook': '469-589-5357',
    'bing': '469-589-5357',
    'direct': '469-589-5357',
  } as Record<string, string>,
  
  // Google Ads pool (when gclid is present)
  GCLID_POOL: '469-589-5357',
};

// Session storage key for persisting assigned number
export const DNI_SESSION_KEY = 'dni_assigned_number';
export const DNI_CONTEXT_KEY = 'dni_context';

export type DNIContext = {
  assignedNumber: string;
  city: string | null;
  campaign: string | null;
  source: string | null;
  medium: string | null;
  gclid: string | null;
  landingPage: string;
  timestamp: number;
};
